import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { FeaturesShowcase } from '../components/FeaturesShowcase';
import { Services } from '../components/Services';
import { TemplatesSection } from '../components/TemplatesSection';
import { PricingSection } from '../components/PricingSection';
import { About } from '../components/About';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export default function Landing() {
  return (
    <div className="app-container">
      <Navbar />
      <main>
        <Hero />
        <FeaturesShowcase />
        <Services />
        <TemplatesSection />
        <PricingSection />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
